import { classicVariant } from './implementations/classic';
import { worldsVariant } from './implementations/worlds';
import { dossierVariant } from './implementations/dossier';
import { workbenchVariant } from './implementations/workbench';
import { simpleVariant } from './implementations/simple';
import type { AppearanceVariant } from './types';

export type { AppearanceVariant } from './types';
export const CLASSIC_VARIANT = classicVariant;

/** Remove an optional entry and its import to retire a presentation safely. */
export const APPEARANCE_VARIANTS: readonly AppearanceVariant[] = [
  classicVariant,
  worldsVariant,
  dossierVariant,
  workbenchVariant,
  simpleVariant,
];
